export const OSS_IMAGE_HOST = 'https://kc-imgs.oss-ap-southeast-5.aliyuncs.com';

const trimSlashes = (value) => String(value || '').trim().replace(/^\/+/, '').replace(/\/+$/, '');

const stripQueryString = (value) => String(value || '').split('?')[0].split('#')[0];

const safeDecode = (value) => {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};

const encodePath = (path) => trimSlashes(path)
    .split('/')
    .filter(Boolean)
    .map((segment) => encodeURIComponent(safeDecode(segment)))
    .join('/');

const unique = (items) => {
    return items.filter((item, index) => item && items.indexOf(item) === index);
};

const buildOssUrl = (path) => {
    const encodedPath = encodePath(path);
    return encodedPath ? OSS_IMAGE_HOST + '/' + encodedPath : '';
};

const getFileNameFromTransactionPath = (path) => {
    const cleanPath = trimSlashes(stripQueryString(path));
    const segments = cleanPath.split('/').filter(Boolean);

    if (segments.length >= 4 && segments[0] === 'kc' && segments[1] === 'transaksi') {
        return safeDecode(segments[segments.length - 1]);
    }

    if (segments.length >= 3 && segments[0] === 'transaksi') {
        return safeDecode(segments[segments.length - 1]);
    }

    return '';
};

const getPathFromFullUrl = (url) => {
    try {
        return trimSlashes(new URL(url).pathname);
    } catch (error) {
        return '';
    }
};

export const buildTransactionPhotoUrls = (schema, fileName) => {
    if (!fileName) {
        return [];
    }

    const photo = String(fileName).trim();
    if (!photo) {
        return [];
    }

    if (/^https?:\/\//i.test(photo)) {
        const path = getPathFromFullUrl(photo);
        const fallbackFileName = getFileNameFromTransactionPath(path);

        return unique([
            photo,
            fallbackFileName ? buildOssUrl('kc/transaksi/' + fallbackFileName) : ''
        ]);
    }

    const cleanPhoto = trimSlashes(stripQueryString(photo));
    const fallbackFileName = getFileNameFromTransactionPath(cleanPhoto);

    if (cleanPhoto.indexOf('kc/transaksi/') === 0) {
        return unique([
            buildOssUrl(cleanPhoto),
            fallbackFileName ? buildOssUrl('kc/transaksi/' + fallbackFileName) : ''
        ]);
    }

    if (cleanPhoto.indexOf('transaksi/') === 0) {
        return unique([
            buildOssUrl('kc/' + cleanPhoto),
            fallbackFileName ? buildOssUrl('kc/transaksi/' + fallbackFileName) : ''
        ]);
    }

    if (cleanPhoto.indexOf('/') >= 0) {
        return unique([
            buildOssUrl(cleanPhoto)
        ]);
    }

    return unique([
        buildOssUrl('kc/transaksi/' + trimSlashes(schema || '') + '/' + cleanPhoto),
        buildOssUrl('kc/transaksi/' + cleanPhoto)
    ]);
};

export const addTransactionPhotoQuery = (baseUrl, version, resizeOptions) => {
    if (!baseUrl) {
        return '';
    }

    const params = [];
    if (resizeOptions) {
        params.push('x-oss-process=image/resize,m_fixed,' + resizeOptions);
    }

    params.push('v=' + encodeURIComponent(version || Date.now()));

    return baseUrl + (baseUrl.indexOf('?') >= 0 ? '&' : '?') + params.join('&');
};

export const getTransactionPhotoUrl = (schema, fileName, version, resizeOptions = 'w_100,h_80') => {
    const urls = buildTransactionPhotoUrls(schema, fileName);
    return urls.length > 0 ? addTransactionPhotoQuery(urls[0], version, resizeOptions) : '';
};
